var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.387 7.615C16.099 3.423 12.595 0 8.203 0 3.68 0 0 3.68 0 8.203c0 4.39 3.422 7.896 7.615 8.184C7.92 20.636 11.472 24 15.797 24 20.32 24 24 20.32 24 15.797c0-4.325-3.364-7.879-7.613-8.182zm-14.98.588a6.797 6.797 0 0113.572-.569 8.168 8.168 0 00-4.443 1.874L8.917 4.653a.703.703 0 00-1.334 0l-2.25 6.75a.704.704 0 001.334.444l.34-1.019h2.268a8.16 8.16 0 00-1.64 4.15c-3.381-.27-6.229-3.117-6.229-6.775zm7.617 1.219H7.476l.774-2.324.774 2.324zm6.773 13.172A6.805 6.805 0 019 15.797 6.805 6.805 0 0115.797 9a6.805 6.805 0 016.797 6.797 6.805 6.805 0 01-6.797 6.797z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 12.422H12.75a.703.703 0 000 1.406h1.136c-.11 1.207-.503 3.14-1.575 3.998a.703.703 0 10.878 1.098c2.115-1.692 2.14-5.632 2.14-5.799a.703.703 0 00-.704-.703zM18.75 14.297h-.797v-1.922a.703.703 0 00-1.406 0v6.75a.703.703 0 001.406 0v-3.422h.797a.703.703 0 000-1.406zM18 2.953A3.05 3.05 0 0121.047 6a.703.703 0 001.406 0A4.458 4.458 0 0018 1.547a.703.703 0 000 1.406zM6 21.047A3.05 3.05 0 012.953 18a.703.703 0 00-1.406 0A4.458 4.458 0 006 22.453a.703.703 0 000-1.406z",
    fill: "#000"
  })));
}

export default SvgIconLanguage;